class SizeChart extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.size-chart-trigger');
    this.content = this.querySelector('.size-chart-content');
    
    if (!this.trigger || !this.content) return;
    
    this.trigger.addEventListener('click', this.toggleChart.bind(this));
  }

  toggleChart() {
    const isExpanded = this.trigger.getAttribute('aria-expanded') === 'true';
    this.trigger.setAttribute('aria-expanded', !isExpanded);
    this.content.hidden = isExpanded;
  }
}

customElements.define('size-chart', SizeChart);